import { GET_HOLDING_ACCOUNTS } from "../types/holdingAccountType";

const initialState = {
    holdingAccounts: [],
    totalElements: 0,
    number: 0,
    size: 0
};

const holdingAccountReducer = (state = initialState, { payload, type }) => {
    switch (type) {
        case GET_HOLDING_ACCOUNTS:
            return {
                ...state,
                holdingAccounts: payload.content,
                totalElements: payload.totalElements,
                size: payload.size,
                number: payload.number
            };
        default:
            return state;
    }
};

export default holdingAccountReducer;
